module.exports = __webpack_public_path__ + "static/media/pin-default-privado.ac8e8f2e.png";